var _circle, _ellipse, _ellipse2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgGenderMale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.1432,
    cy: 30.9005,
    r: 29.9185,
    fill: "#FFE8DB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.9216,
    cy: 37.0911,
    rx: 2.06335,
    ry: 3.09502,
    fill: "#262626"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.4284,
    cy: 37.0911,
    rx: 2.06335,
    ry: 3.09502,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3018 44.314H26.5326C26.5326 46.3773 28.0801 47.9248 31.1751 47.9248C34.0931 47.9248 35.1299 45.6895 35.3018 44.314Z",
    fill: "#F09387"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7828 1.8039C13.4118 -6.44948 1.37557 15.5564 0 28.6243V31.2037C2.88869 27.077 12.8959 21.6841 20.1176 20.3711C25.7919 19.3394 30.6063 20.715 33.0136 22.4344C36.7276 19.1331 52.7873 25.1854 60.3529 28.6243C61.3846 19.8552 57.9457 14.6968 54.6787 13.1494C52.0995 6.44351 44.19 2.66369 41.7828 1.8039Z",
    fill: "#434379"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40016 14.1149C3.89 15.1568 2.64648 15.2545 0 24.0127C11.8744 24.0127 36.5802 24.6804 60.8688 24.1295C60.8688 20.4843 58.5862 15.9779 56.5696 14.1488C31.7413 13.5979 15.7348 13.5051 4.40016 14.1149Z",
    fill: "#4F97F5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGenderMale);
export default __webpack_public_path__ + "static/media/img_gender_male.4f301c8965690fd6a6db0415fadcdab8.svg";
export { ForwardRef as ReactComponent };